module.exports = new Promise((resolve, reject) => {
          const remoteUrl = "/interactive/assets";
          import(remoteUrl + "/remoteEntry.js")
            .then(function(m) { resolve({ get: m.get, init: m.init }); })
            .catch(reject);
        });